module.exports = __webpack_public_path__ + "static/media/phone_notifs.c9028aad.webp";